import { useRef, useEffect } from 'react';

/**
 * Hook для сброса только dirty состояния Formik после успешной операции
 * Не делает навигацию - просто сбрасывает dirty и оставляет текущие значения
 * @param {boolean} isSuccess - флаг успешной операции
 */
const useFormikDirtyReset = isSuccess => {
  const formikRef = useRef();

  useEffect(() => {
    if (isSuccess && formikRef.current) {
      // Reset Formik dirty state while keeping current values
      if (formikRef.current) {
        const currentValues = formikRef.current.values;
        formikRef.current.resetForm({
          values: currentValues,
          initialValues: currentValues,
        });
      }
    }
  }, [isSuccess]);

  return formikRef;
};

export default useFormikDirtyReset;
